import React from "react";

const UnlcockedIcon = ({ width = 21, height = 21, fill = "#BBBBBB" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3328_85480)">
      <path
        d="M14.373 7.06803H6.03971V6.23469C6.03946 5.31086 6.34623 4.41314 6.91181 3.68267C7.47739 2.9522 8.26969 2.43041 9.16416 2.19933C10.0586 1.96825 11.0045 2.04098 11.8531 2.4061C12.7018 2.77122 13.405 3.40801 13.8522 4.21636C13.9053 4.31206 13.9768 4.39636 14.0625 4.46445C14.1482 4.53253 14.2465 4.58306 14.3517 4.61317C14.457 4.64327 14.5671 4.65235 14.6759 4.63988C14.7846 4.62742 14.8898 4.59366 14.9855 4.54053C15.0812 4.4874 15.1655 4.41594 15.2336 4.33023C15.3017 4.24452 15.3522 4.14624 15.3824 4.041C15.4125 3.93576 15.4215 3.82562 15.4091 3.71687C15.3966 3.60812 15.3628 3.5029 15.3097 3.4072C14.6833 2.27579 13.6987 1.38463 12.5106 0.87379C11.3225 0.362951 9.99835 0.261403 8.74627 0.585108C7.4942 0.908812 6.38519 1.63941 5.59357 2.66207C4.80195 3.68473 4.37262 4.94145 4.37305 6.23469V7.42136C3.63085 7.74528 2.99912 8.27846 2.55513 8.9557C2.11113 9.63295 1.87411 10.4249 1.87305 11.2347V16.2347C1.87437 17.3394 2.31378 18.3984 3.0949 19.1795C3.87601 19.9606 4.93505 20.4 6.03971 20.4014H14.373C15.4777 20.4 16.5367 19.9606 17.3179 19.1795C18.099 18.3984 18.5384 17.3394 18.5397 16.2347V11.2347C18.5384 10.13 18.099 9.07099 17.3179 8.28988C16.5367 7.50876 15.4777 7.06935 14.373 7.06803ZM16.873 16.2347C16.873 16.8977 16.6097 17.5336 16.1408 18.0025C15.672 18.4713 15.0361 18.7347 14.373 18.7347H6.03971C5.37667 18.7347 4.74079 18.4713 4.27195 18.0025C3.80311 17.5336 3.53971 16.8977 3.53971 16.2347V11.2347C3.53971 10.5717 3.80311 9.93577 4.27195 9.46693C4.74079 8.99809 5.37667 8.73469 6.03971 8.73469H14.373C15.0361 8.73469 15.672 8.99809 16.1408 9.46693C16.6097 9.93577 16.873 10.5717 16.873 11.2347V16.2347Z"
        fill={fill}
      />
      <path
        d="M10.2064 12.0679C9.98537 12.0679 9.77341 12.1557 9.61712 12.3119C9.46084 12.4682 9.37305 12.6802 9.37305 12.9012V14.5679C9.37305 14.7889 9.46084 15.0008 9.61712 15.1571C9.77341 15.3134 9.98537 15.4012 10.2064 15.4012C10.4274 15.4012 10.6394 15.3134 10.7956 15.1571C10.9519 15.0008 11.0397 14.7889 11.0397 14.5679V12.9012C11.0397 12.6802 10.9519 12.4682 10.7956 12.3119C10.6394 12.1557 10.4274 12.0679 10.2064 12.0679Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_3328_85480">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.206055 0.401367)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default UnlcockedIcon;
